import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.interface';
import { 
  SubscriptionPlan, 
  CreateSubscriptionPlanRequest, 
  UpdateSubscriptionPlanRequest 
} from '../models/subscription-plan.model';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPlanService {
  private baseUrl = '/api/admin/subscriptions/plans';

  constructor(private http: HttpClient) {}

  getPlans(): Observable<ApiResponse<SubscriptionPlan[]>> {
    return this.http.get<ApiResponse<SubscriptionPlan[]>>('/api/subscriptions/plans');
  }

  getPlanById(id: number): Observable<ApiResponse<SubscriptionPlan>> {
    return this.http.get<ApiResponse<SubscriptionPlan>>(`/api/subscriptions/plans/${id}`);
  }

  createPlan(plan: CreateSubscriptionPlanRequest): Observable<ApiResponse<SubscriptionPlan>> {
    return this.http.post<ApiResponse<SubscriptionPlan>>(this.baseUrl, plan);
  }

  updatePlan(id: number, plan: UpdateSubscriptionPlanRequest): Observable<ApiResponse<SubscriptionPlan>> {
    return this.http.put<ApiResponse<SubscriptionPlan>>(`${this.baseUrl}/${id}`, plan);
  }

  deactivatePlan(id: number): Observable<ApiResponse<SubscriptionPlan>> {
    return this.http.delete<ApiResponse<SubscriptionPlan>>(`${this.baseUrl}/${id}`);
  }

  reactivatePlan(id: number): Observable<ApiResponse<SubscriptionPlan>> {
    return this.http.put<ApiResponse<SubscriptionPlan>>(`${this.baseUrl}/${id}/reactivate`, {});
  }
}
